import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=75c7ed8a"
import script from "./UserPage.vue?vue&type=script&lang=js"
export * from "./UserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports